import { Shape } from '@mui/material/styles'

export const shape: Shape = {
  borderRadius: 4,
}
